import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ToTopIcon } from '../icons';
import { ToolbarButton } from '../ui';
import { moveObjectsToTop } from '../project';
import { getCurrentPieceID } from '../stage';
import { getSelectedObjectsIDs } from '../editor';

const ButtonMoveToTop = ({ disabled, onClick }) => {
  if (disabled) {
    return null;
  }
  return <ToolbarButton icon={<ToTopIcon />} onClick={onClick} />;
};

ButtonMoveToTop.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const reduxConnector = connect(
  state => {
    const pieceID = getCurrentPieceID(state);
    const ids = getSelectedObjectsIDs(state);
    let disabled = true;
    if (ids.size > 0) {
      disabled = false;
    }
    return { ids, disabled, pieceID };
  },
  { moveObjectsToTop },
  ({ ids, pieceID, ...state }, actions) => ({
    ...state,
    onClick: () => actions.moveObjectsToTop({ pieceID, ids }),
  }),
);

export default reduxConnector(ButtonMoveToTop);
